import React from 'react';
import Icon from '../../../components/AppIcon';

const ResourceSidebar = ({ applicationLink }) => {
  const hasApplicationLink = applicationLink && (applicationLink?.url || typeof applicationLink === 'string');
  const applicationUrl = applicationLink?.url || applicationLink;

  // Only render if application link exists
  if (!hasApplicationLink) {
    return null;
  }

  return (
    <div className="space-y-4 md:space-y-5 lg:space-y-6">
      {/* Apply Now Section - Only shows when application link exists */}
      <div className="bg-gradient-to-br from-primary to-secondary rounded-lg shadow-lg p-5 md:p-6 text-primary-foreground">
        <div className="flex items-center gap-3 mb-4">
          <div className="bg-white/20 p-2 rounded-lg">
            <Icon name="FileText" size={24} color="currentColor" />
          </div>
          <h3 className="text-lg md:text-xl font-heading font-bold">
            Apply Now
          </h3>
        </div>
        
        <p className="text-sm mb-4 opacity-95 leading-relaxed">
          Ready to take the next step? Submit your application directly through our online portal.
        </p>
        <a
          href={applicationUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center gap-2 w-full bg-white text-primary hover:bg-white/90 font-semibold shadow-md hover:shadow-lg transition-all px-4 py-3 rounded-lg"
        >
          <span>Go to Application Portal</span>
          <Icon name="ExternalLink" size={18} color="currentColor" />
        </a>
      </div>

      {/* Additional Info Card */}
      <div className="bg-card rounded-lg shadow-md p-4 md:p-5 border border-border">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-primary)" className="mt-1 flex-shrink-0" />
          <div>
            <h4 className="font-semibold text-foreground mb-2">Need Help?</h4>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Our admission team is here to guide you through the application process. Feel free to reach out anytime!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourceSidebar;